import { UserBountyContentType } from '../../../generated/backendGraphql'
import InstagramLogo from '../../../assets/instagram.png'
import TikTokLogo from '../../../assets/tiktok.png'
import DefaultLogo from '../../../assets/tiktok.png'

export const contentType = (code: UserBountyContentType | null | undefined) => {
  if (!code) return 'An unknown error occurred selecting content type.'

  switch (code) {
    case 'TIKTOK_VIDEO':
      return 'TikTok'
    case 'INSTAGRAM_REEL':
      return 'Instagram Reel'
    case 'INSTAGRAM_STORY':
      return 'Instagram Story'

    default:
      return 'An unknown error occurred.'
  }
}

export const getSocialMediaLogo = (
  bountyContentType: UserBountyContentType,
) => {
  switch (bountyContentType) {
    case 'INSTAGRAM_REEL':
    case 'INSTAGRAM_STORY':
      return InstagramLogo
    case 'TIKTOK_VIDEO':
      return TikTokLogo
    default:
      return DefaultLogo
  }
}
